export const url = "https://app.powerstream.pl";
// export const url = "http://192.168.22.48";
